import styled from 'styled-components';

interface IProgressBarProps {
	progress: number;
	className?: string;
	small?: boolean;
}

interface IStylingProps {
	small?: boolean;
}

const ProgressBarTrack = styled.div<IStylingProps>`
	width: 100%;
	height: ${props => props.small ? '2px' : '8px'};
	border-radius: 4px;
	overflow: hidden;
	background: ${({ theme }) => theme.colors.lightBlueDark};
`;

const ProgressBarIndicator = styled.div`
	height: 100%;
	background: ${({ theme }) => theme.colors.primary};
	transition: 150ms width ease-out;
	border-radius: 16px;
`;

export default function ProgressBar({ progress, small = false, className }: IProgressBarProps) {
	return (
		<ProgressBarTrack className={className} small={small}>
			<ProgressBarIndicator
				style={{
					width: `${progress * 100}%`,
				}}
			/>
		</ProgressBarTrack>
	);
}
